import React, { useEffect, useRef, useState } from "react";

import { StickyContainerProps } from "./StickyContainer.types";

import "./StickyContainer.scss";

const StickyContainer: React.FC<StickyContainerProps> = ({
  children,
  backgroundColor,
  top = "0px",
  primaryNav,
}) => {
  const mainRef = useRef(null);

  const [initialOffset, _setInitialOffset] = useState<number | undefined>();
  const initialOffsetRef = useRef(initialOffset);
  const setInitialOffset = (value: number | undefined) => {
    initialOffsetRef.current = value;
    _setInitialOffset(value);
  };

  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const { offsetTop } = mainRef.current!;

    setInitialOffset(offsetTop);
  }, [mainRef]);

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.pageYOffset - (initialOffsetRef.current || 0));
    };

    window.addEventListener("scroll", updatePosition);
    updatePosition();
    return () => window.removeEventListener("scroll", updatePosition);
  }, []);
  return (
    <div
      ref={mainRef}
      data-testid="StickyContainer"
      className={`mp-atoms-stickycontainer--main${
        scrollPosition > 5 ? " shadow" : ""
      }`}
      style={{
        top: `calc(${top})`,
        background: backgroundColor || "none",
        zIndex: primaryNav ? 7000 : 6000,
      }}
    >
      {children}
    </div>
  );
};

export default StickyContainer;
